import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Form, Spinner } from "react-bootstrap";
import { FaImage } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { IoMdRemoveCircle } from "react-icons/io";
import {
  getvehicleType,
  updatevehicleType,
} from "../../store/slices/vehicletype";
import { uploadImage } from "../../utils/helpers/fileupload";
import { getVendor } from "../../store/slices/vendor";
import { FaPlus, FaTrash } from "react-icons/fa";

export default function EditVehicle() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));
  const token = user?.data?.accessToken;

  const [form, setForm] = useState({
    name: "",
    capacity: "",
    ac: false,
    fuelType: "",
    description: "",
  });

  const [vendorform, setvendorForm] = useState({
    vendors: [
      {
        vendor: "",
        pricePerDay: "",
      },
    ],
  });

  const { vendorList } = useSelector((state) => state.vendor);

  const vendors = vendorList?.vendors || [];

  const [preview, setPreview] = useState(null);
  const [image, setImage] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const [submitloading, setsubmitLoading] = useState(false);

  const [locationErrors, setLocationErrors] = useState([]);

  useEffect(() => {
    const item = { service: "VEHICLE" };
    dispatch(getVendor(item));
  }, [dispatch]);

  useEffect(() => {
    const fetchVehicle = async () => {
      try {
        const res = await dispatch(getvehicleType({ id })).unwrap();

        const data = res?.vehicle;

        setForm({
          name: data.name || "",
          capacity: data.capacity || "",
          pricePerDay: data.pricePerDay || "",
          ac: data.ac || false,
          fuelType: data.fuelType || "",
          description: data.description || "",
        });

        setvendorForm({
          vendors:
            data?.vendors?.length > 0
              ? data.vendors.map((v) => ({
                  vendor: v.vendor || "",

                  pricePerDay: v.pricePerDay || "",
                }))
              : [
                  {
                    vendor: "",
                    pricePerDay: "",
                  },
                ],
        });

        setPreview(data.image);
      } catch (err) {
        toast.error("Failed to fetch vehicle data");
      }
    };

    if (id) fetchVehicle();
  }, [dispatch, id]);

  const validateLocations = () => {
    let isValid = true;
    const updatedErrors = [];

    vendorform.vendors.forEach((loc, index) => {
      const errors = {};

      if (!loc.pricePerDay) {
        errors.pricePerDay = "Please enter price";
        isValid = false;
      }

      if (!loc.vendor) {
        errors.vendor = "Please select vendor";
        isValid = false;
      }

      updatedErrors[index] = errors;
    });

    setLocationErrors(updatedErrors);
    return isValid;
  };

  const addLocationRow = () => {
    setvendorForm((prev) => ({
      ...prev,
      vendors: [...prev.vendors, { vendor: "", pricePerDay: "" }],
    }));
  };

  const removeLocationRow = (index) => {
    const updated = [...vendorform.vendors];
    updated.splice(index, 1);
    setvendorForm({
      ...vendorform,
      vendors: updated,
    });
  };

  const handleLocationChange = (index, field, value) => {
    const updated = [...vendorform.vendors];
    const updatedErrors = [...locationErrors];

    if (field === "pricePerDay") {
      value = value.replace(/[^0-9]/g, "");

      value = value.slice(0, 5);

      const numeric = Number(value);

      if (numeric <= 0 || numeric > 20000) {
        updatedErrors[index] = {
          ...updatedErrors[index],
          pricePerDay: "Please enter price between 1 to 20000",
        };
      } else {
        updatedErrors[index] = {
          ...updatedErrors[index],
          pricePerDay: "",
        };
      }
    }
    updated[index][field] = value;

    setvendorForm({
      ...vendorform,
      vendors: updated,
    });

    setLocationErrors(updatedErrors);
  };

  const validate = () => {
    let newErrors = {};

    if (!form.name.trim()) newErrors.name = "Please enter vehicle name";

    if (!form.capacity || form.capacity <= 0)
      newErrors.capacity = "Please enter valid capacity";

    if (!form.fuelType) newErrors.fuelType = "Please select fuel type";

    if (!form.description.trim())
      newErrors.description = "Please enter description";

    if (!image && !preview) newErrors.image = "Please upload image";

    let vendorErrors = [];
    let isValid = true;

    vendorform.vendors.forEach((loc, index) => {
      const errors = {};

      if (!loc.vendor) {
        errors.vendor = "Please select vendor";
        isValid = false;
      }

      if (!loc.pricePerDay) {
        errors.pricePerDay = "Please enter price";
        isValid = false;
      } else if (
        Number(loc.pricePerDay) <= 0 ||
        Number(loc.pricePerDay) > 20000
      ) {
        errors.pricePerDay = "Price must be between 1 and 20000";
        isValid = false;
      }

      vendorErrors[index] = errors;
    });

    setLocationErrors(vendorErrors);

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    let newErrors = { ...errors };

    if (name === "name") {
      if (!/^[a-zA-Z0-9][\s\S]*$/.test(value)) return;

      if (!value.trim()) {
        newErrors.name = "Please enter vehicle name";
      } else {
        delete newErrors.name;
      }
    }

    //  Capacity <----
    else if (name === "capacity") {
      if (!/^[0-9]*$/.test(value)) return;

      if (!value) {
        newErrors.capacity = "Please enter capacity";
      } else {
        delete newErrors.capacity;
      }
    }

    // -- > Price
    else if (name === "pricePerDay") {
      if (!/^[0-9]*$/.test(value)) return;

      if (!value) {
        newErrors.pricePerDay = "Please enter price per day";
      } else {
        delete newErrors.pricePerDay;
      }
    }

    //  Fuel -- > Type
    else if (name === "fuelType") {
      if (!value) {
        newErrors.fuelType = "Please select fuel type";
      } else {
        delete newErrors.fuelType;
      }
    }

    // --- >  Description
    else if (name === "description") {
      if (!value.trim()) {
        newErrors.description = "Please enter description";
      } else {
        delete newErrors.description;
      }
    }

    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });

    setErrors(newErrors);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const maxSize = 5 * 1024 * 1024;

    if (file.size > maxSize) {
      setErrors((prev) => ({
        ...prev,
        image: "Image size must be less than 5MB",
      }));

      return;
    }

    setImage(file);
    setPreview(URL.createObjectURL(file));

    setErrors((prev) => {
      const copy = { ...prev };
      delete copy.image;
      return copy;
    });
  };

  const removeImage = () => {
    setImage(null);
    setPreview(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      setsubmitLoading(true);

      let fileUrl = preview;

      if (image) {
        fileUrl = await uploadImage(image, token);
      }

      const payload = {
        id,
        ...form,
        capacity: Number(form.capacity),
        vendors: vendorform.vendors,
        image: fileUrl,
      };

      await dispatch(updatevehicleType(payload)).unwrap();

      toast.success("Vehicle updated successfully");
      navigate("/admin/vehicle");
    } catch (error) {
      toast.error(error || "Failed to update vehicle");
    } finally {
      setsubmitLoading(false);
    }
  };

  return (
    <>
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/admin/home" className="breadcrumb-link active">
            Home
          </Link>

          <span className="breadcrumb-separator">|</span>
          <Link to="/admin/vehicle" className="breadcrumb-link active">
            Vehicle
          </Link>

          <span className="breadcrumb-separator">|</span>

          <span
            className="breadcrumb-link inactive"
            onClick={() => navigate("/admin/editvehicle")}
          >
            Edit Vehicle
          </span>
        </div>
      </div>
      <Container fluid className="mt-3">
        <Card className="p-4 shadow-sm">
          <Form onSubmit={handleSubmit}>
            <Row>
              {/* Vehicle Name */}
              <Col md={3} className="mb-3">
                <Form.Label>Name</Form.Label>
                <div className="position-relative">
                  <Form.Control
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    placeholder="Enter vehicle name"
                    maxLength={30}
                  />
                </div>
                {errors.name && (
                  <small className="text-danger">{errors.name}</small>
                )}
              </Col>

              {/* Capacity */}
              <Col md={3} className="mb-3">
                <Form.Label>Capacity</Form.Label>
                <div className="position-relative">
                  <Form.Control
                    type="text"
                    name="capacity"
                    value={form.capacity}
                    onChange={handleChange}
                    placeholder="Enter capacity"
                    maxLength={2}
                  />
                </div>
                {errors.capacity && (
                  <small className="text-danger">{errors.capacity}</small>
                )}
              </Col>
              {/* Fuel Type */}
              <Col md={3} className="mb-3">
                <Form.Label>Fuel Type</Form.Label>
                <div className="position-relative">
                  <Form.Select
                    name="fuelType"
                    value={form.fuelType}
                    onChange={handleChange}
                  >
                    <option value="">Select fuel type</option>
                    <option value="PETROL">Petrol</option>
                    <option value="DIESEL">Diesel</option>
                    <option value="CNG">CNG</option>
                    <option value="EV">EV</option>
                  </Form.Select>
                </div>
                {errors.fuelType && (
                  <small className="text-danger">{errors.fuelType}</small>
                )}
              </Col>

              {/* AC */}
              {/* Description */}
              <Col md={6} className="mb-3">
                <Form.Label>Description</Form.Label>
                <div className="position-relative">
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="description"
                    value={form.description}
                    onChange={handleChange}
                    placeholder="Enter vehicle description"
                  />
                </div>
                {errors.description && (
                  <small className="text-danger">{errors.description}</small>
                )}
              </Col>

              {/* Image -- > Upload */}
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Image</Form.Label>

                  <div
                    className="custom-file-uploader"
                    onClick={() =>
                      document.getElementById("imageUpload").click()
                    }
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                      e.preventDefault();
                      const file = e.dataTransfer.files[0];
                      handleImageChange({ target: { files: [file] } });
                    }}
                  >
                    {!preview ? (
                      <div className="upload-placeholder">
                        <div className="upload-icon-box">
                          <FaImage className="upload-icon-white" />
                        </div>
                        <p className="mb-1">Click or Drag Image Here</p>
                      </div>
                    ) : (
                      <div className="image-preview-wrapper">
                        <img
                          src={preview}
                          alt="preview"
                          className="preview-img"
                        />
                        <IoMdRemoveCircle
                          size={24}
                          className="remove-icon"
                          onClick={(e) => {
                            e.stopPropagation();
                            removeImage();
                          }}
                        />
                      </div>
                    )}

                    <Form.Control
                      id="imageUpload"
                      type="file"
                      accept="image/*"
                      onChange={handleImageChange}
                      hidden
                    />
                  </div>

                  {errors.image && (
                    <small className="text-danger d-block mt-2">
                      {errors.image}
                    </small>
                  )}
                </Form.Group>
              </Col>

              <Col md={6} className="mb-3 my-4">
                <Form.Check
                  type="checkbox"
                  label="AC Available"
                  name="ac"
                  checked={form.ac}
                  onChange={handleChange}
                />
              </Col>

              <Row className="align-items-end mt-3">
                <Col
                  md={7}
                  className="d-flex justify-content-between align-items-center"
                >
                  <h5 className="d-flex flex-column">Vendor and Price</h5>

                  <button
                    type="button"
                    class="btn btn-outline-primary"
                    onClick={addLocationRow}
                  >
                    +
                  </button>
                </Col>

                {vendorform.vendors.map((loc, index) => (
                  <Row key={index} className="mt-2 align-items-center">
                    <Col md={3}>
                      <Form.Label>Vendor</Form.Label>
                      <Form.Select
                        value={loc.vendor}
                        onChange={(e) =>
                          handleLocationChange(index, "vendor", e.target.value)
                        }
                      >
                        <option value="">Select</option>

                        {vendors?.map((vendor) => (
                          <option key={vendor._id} value={vendor._id}>
                            {vendor.name}
                          </option>
                        ))}
                      </Form.Select>

                      {locationErrors[index]?.vendor && (
                        <small className="text-danger">
                          {locationErrors[index].vendor}
                        </small>
                      )}
                    </Col>

                    {/* Price */}
                    <Col md={3}>
                      <Form.Label>Price per day</Form.Label>
                      <Form.Control
                        type="text"
                        name="pricePerDay"
                        placeholder="Enter Price per day"
                        value={loc.pricePerDay}
                        onChange={(e) =>
                          handleLocationChange(
                            index,
                            "pricePerDay",
                            e.target.value,
                          )
                        }
                      />
                      {locationErrors[index]?.pricePerDay && (
                        <small className="text-danger">
                          {locationErrors[index].pricePerDay}
                        </small>
                      )}
                    </Col>

                    {/* Remove Button */}
                    <Col md={1} className="text-end mt-3">
                      {vendorform.vendors.length > 1 && (
                        <button
                          type="button"
                          class="btn btn-outline-danger"
                          onClick={() => removeLocationRow(index)}
                        >
                          <FaTrash size={14} />
                        </button>
                      )}
                    </Col>
                  </Row>
                ))}
              </Row>

              <Col
                md={12}
                className="mt-3 d-flex justify-content-center gap-3 mt-5 mb-5"
              >
                <button
                  type="button"
                  className="cancel-btn"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="submit-btn"
                  disabled={submitloading}
                >
                  {submitloading ? (
                    <>
                      <Spinner
                        animation="border"
                        size="sm"
                        variant="primary"
                        className="me-2"
                      />
                      Updating...
                    </>
                  ) : (
                    "Update"
                  )}
                </button>
              </Col>
            </Row>
          </Form>
        </Card>
      </Container>
    </>
  );
}
